// extracted by mini-css-extract-plugin
export default {"timeLimit":"NewQuestion_timeLimit__U8fzx","cardDashed":"NewQuestion_cardDashed__HeaPZ","hasAction":"NewQuestion_hasAction__0DyK4","inputAction":"NewQuestion_inputAction__AUnjZ"};